import { useState, useEffect } from 'react';
import { Toggle } from 'rsuite';
import { devLog } from '../utils/devLog';

export const DisplayTimerEnabledToggleItem = ({ register, onChange, disabled }) => {
  const [value, setValue] = useState(register.enabled);
  const updateValue = (value) => {
    setValue(value);
    onChange(register, value);
  };
  useEffect(() => {
    const theValue = register.enabled;
    setValue(theValue);
    devLog('timer enabled changed', theValue);
  }, [register.enabled]);
  return (
    <Toggle
      checkedChildren="Enabled"
      unCheckedChildren="Disabled"
      checked={value}
      disabled={disabled}
      onChange={updateValue}
    />
  );
};
